export const NEW_CLIENT = 1

export const EXISTING_CLIENT = 2
